import StoreCtx, { IStoreContext } from "../../context/store-context";
import { useContext } from "react";
import { Dispatch } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Constants, Enums, Utilities } from "@utils";
import { UserDTO } from "@models/*";
import {
  ErrorLoggerService,
  IErrorLoggerService,
} from "@services/base/error-logger.service";

const { StoreContext } = StoreCtx;
export class BasePresenter<T> {
  protected view: T;
  protected context: IStoreContext;
  protected _dispatcher: Dispatch<any>;

  public currentUser: UserDTO;
  public _errorLoggerService: IErrorLoggerService;

  private _errorLogService: IErrorLoggerService;

  public constructor(_view?: T) {
    this.view = _view;
    this.context = useContext(StoreContext);
    this._dispatcher = useDispatch();
    this.currentUser = useSelector(
      this.context.sessionStore.selectUser
    ) as UserDTO;
    this._errorLogService = new ErrorLoggerService(Enums.ListTypes.ErrorLog);
  }

  protected syncDispatcher(reduxAction: any) {
    this._dispatcher(reduxAction);
  }

  protected dispatcher(reduxAction: any) {
    this._dispatcher(reduxAction);
  }

  protected dispatcherSetLoading() {
    this._dispatcher(
      this.context.sessionStore.actions.setLoadingContainer(true)
    );
  }

  protected dispatcherUnsetSetLoading() {
    this._dispatcher(
      this.context.sessionStore.actions.setLoadingContainer(false)
    );
  }
  protected dispatcherProgress(progress: number): void {
    this._dispatcher(
      this.context.sessionStore.actions.setProgressLoading(progress)
    );
  }
  protected dispatcherPendingLoad(pendingLoad: number) {
    this._dispatcher(
      this.context.sessionStore.actions.setPendingLoad(pendingLoad)
    );
  }

  //public validateUserInfo() {
    //if (
    //  !Utilities.isNullObject(this.currentUser) &&
    //  !Utilities.isNullObject(this.currentUser.userGroups)
    //) {
    //  if (
    //    this.currentUser.userGroups.length === 0 ||
    //    Utilities.isNullObject(
    //      this.currentUser.userGroups.find(
    //        (x) => x.displayName === Constants.UserConfiguration.ProyectaGroup
    //      )
    //    )
    //  ) {
    //    this.context.history.push("/not-authorized");
    //  }
    //}
  //}

  public async writeErrorLog(error: Error, payload?: object) {
    return this._errorLogService.writeError(error, payload);
  }
}
